import { useQuery } from "@tanstack/react-query";
import { fetchPrismicNewsByEveryTags } from "../../prismic/prismic.config";

export const usePrismicNews = (tags: string[]) =>
  useQuery(["news", tags], () => fetchPrismicNewsByEveryTags(tags), {
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60, // 1 Minute
    refetchInterval: 1000 * 60, // 1 Minute
    staleTime: 1000 * 60, // 1 Minute
  });
